<script>
    import * as m from "@app/paraglide/messages.js";
    import { metricsState } from "@app/store/metricsStore.svelte.js";
    /** @type {{wpm?: number, cps?: number, duration?: number, totalWords?: number, lineInfo?: number[], totalChars?: number, eventGroupSettings?: any}} */
    let {
        wpm = 0,
        cps = 0,
        duration = 0,
        totalWords = 0,
        lineInfo = [],
        totalChars = 0,
        eventGroupSettings = {}
    } = $props();

    let fontSizeStyle = $derived(`font-size: ${metricsState.fontSize}px;`);

    let wpmClass = $derived(
        wpm/eventGroupSettings?.maxWpm >= 1 
            ? 'text-danger' 
            : wpm/eventGroupSettings?.maxWpm >= 0.9 
                ? 'text-warning' 
                : 'text-dark'
    );

    let durationClass = $derived(
        duration > eventGroupSettings?.maxDuration || duration < eventGroupSettings?.minDuration 
            ? 'text-danger' 
            : 'text-dark'
    );

    let lineInfoClass = $derived(
        lineInfo && (
            lineInfo.some(el => el > eventGroupSettings?.maxChars) || 
            lineInfo.length > eventGroupSettings?.maxLines
        ) 
            ? 'text-danger' 
            : 'text-dark'
    );

    function getClass(cps) {
        if (!eventGroupSettings?.maxCps) return 'text-dark';
        
        let readingRate = cps / eventGroupSettings.maxCps;
        if (readingRate < 0.8) {
            return 'text-dark';
        } else if (readingRate >= 1) {
            return 'text-danger';
        } else {
            return 'text-warning';
        }
    }
</script>

<div id="metricsContainer" role="group" aria-label={m.event_metrics_aria_label()}>
    <!-- WPM Words Per Minute -->
    {#if metricsState.visibleMetrics.wpm}
    <p id="wpmDisplay" 
       aria-label={m.event_metrics_wpm_aria_label({wpm})} 
       class="{wpmClass} m-0 text-truncate" 
       style={fontSizeStyle}
       title={m.event_metrics_wpm_title({wpm})}>
         {wpm} {m.event_metrics_wpm_unit()}
    </p>
    {/if}
    
    <!-- CPS Characters Per Second -->
    {#if metricsState.visibleMetrics.cps}
    <p class="{getClass(cps)} m-0 text-truncate" 
       style="--cps-ratio: {cps/(eventGroupSettings?.maxCps || 1)}; {fontSizeStyle}"
       title={m.event_metrics_cps_title({cps})}>
         {cps} {m.event_metrics_cps_unit()}
    </p>
    {/if}
    
    <!-- Duration Seconds -->
    {#if metricsState.visibleMetrics.duration}
    <p class="{durationClass} m-0 text-truncate" 
       style={fontSizeStyle}
       title={m.event_metrics_duration_title({duration})}>
         {duration} {m.event_metrics_seconds_unit()}
    </p>
    {/if}
    
    <!-- Total Words -->
    {#if metricsState.visibleMetrics.words}
    <p class="text-dark m-0 text-truncate" 
       style={fontSizeStyle}
       title={m.event_metrics_words_title({totalWords})}>
         {totalWords} {m.event_metrics_words_unit()}
    </p>
    {/if}
    
    <!-- Character Count Per Line -->
    {#if metricsState.visibleMetrics.chars}
    <p class="{lineInfoClass} mb-2 text-truncate" 
       style={fontSizeStyle}
       title={m.event_metrics_chars_title({lineInfo: lineInfo && lineInfo.join(','), totalChars})}>
       ({lineInfo && lineInfo.join(',')})={totalChars}
    </p>
    {/if}
</div>